/**
 * Motion tokens — TypeScript mirror of CSS motion custom properties.
 * Used in GSAP tweens where CSS variables can't be read directly.
 */

export const easing = {
  cinematic: "cubic-bezier(0.87, 0, 0.13, 1)",
  crush: "cubic-bezier(0.7, 0, 0.3, 1)",
  unfold: "cubic-bezier(0.25, 1, 0.5, 1)",
  blade: "cubic-bezier(0.83, 0, 0.17, 1)",
} as const;

/**
 * GSAP-compatible ease strings for named curves.
 * Use these in GSAP tweens via `ease: gsapEase.cinematic`.
 */
export const gsapEase = {
  cinematic: "power3.inOut",
  crush: "power2.inOut",
  unfold: "power2.out",
  blade: "expo.inOut",
} as const;

export const duration = {
  instant: 0.12,
  short: 0.36,
  medium: 0.8,
  long: 1.2,
  xl: 2.0,
  massive: 3.5,
} as const;

/**
 * Smooth scroll tuning — heavier than Variant v1's 0.08 for more drag.
 */
export const smoothScroll = {
  lerp: 0.06,
  smoothWheel: true,
  wheelMultiplier: 1,
  touchMultiplier: 2,
} as const;

/**
 * Grain shader tuning — mid-tone distribution (Variant v2 technique).
 */
export const grain = {
  opacity: 0.45,
  breathingMin: 0.38,
  breathingMax: 0.48,
  noiseScale: 100,
  timeScale: 0.1,
} as const;
